import React, { useEffect, useState } from "react";
import { AppContext } from "../App";
import MessageInfo from "../common/MessageInfo";
import { useFetchSeoSettings } from "../data/fetchSeoSettings";
import { SeoContext } from "../data/seo/SeoContextProvider";
import SeoMainContainer from "../data/seo/SeoMainContainer";
import SeoMetaTags from "../data/seo/SeoMetaTags";
import { useHandleSeoSettings } from "../data/seo/seoUtils";
import { getConfiguration } from '../data/utils/configuration';
import { labels } from "../data/labels";

function PrematchNoEvents(props) {
    const conf = getConfiguration();
    const cfgSeo = conf.seo;
    const appContext = React.useContext(AppContext);
    const seoContext = React.useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,true,cfgSeo);

    const [label,setLabel] = useState(null);
    useHandleSeoSettings(seoSettingsState);

    useEffect(() => {
        if(seoSettingsState.data && seoSettingsState.data.seo ){
            setLabel(seoSettingsState.data.seo.label || '');
        }
    }, [seoSettingsState.data]);

    useEffect(() => {
        if(appContext.seoRoutePath?.[window.location.pathname]){
            seoContext.refreshPathname(appContext.seoRoutePath[window.location.pathname],appContext.location.current);
        }
    }, []);
   
    return (
        <>
            <SeoMetaTags />
            {label && 
            <>
            <div className="prematch-no-events" >
                <nav id="nav-go-back" className="nav-go-back">
                    <div className="title-container">
                        <span className="nav-section-title" id="nav-section-title">
                                <h1 className="nav-breadcrumb-label">{label}</h1>
                        </span>
                    </div>
                </nav>
                <MessageInfo message={labels['live_page.streams_schedule.no_matches']} />
                <SeoMainContainer />
            </div>
             </>
            }
        </>
    );
}

export default PrematchNoEvents;